import React, { useState } from "react";
import {
  Checkbox,
  FormControlLabel,
  IconButton,
  Menu,
  MenuItem,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";

const TaskCheckbox = ({ task, completedTasks, handleCheckboxSelect }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const status = completedTasks[task._id] || "none";

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => setAnchorEl(null);

  const handleSelect = (option) => {
    handleCheckboxSelect(option, task);
    handleClose();
  };

  const getIcon = () => {
    if (status === "true") return <CheckCircleIcon color="success" />;
    if (status === "omitted") return <CancelIcon color="error" />;
    return <RadioButtonUncheckedIcon />;
  };

  return (
    <>
      <FormControlLabel
        control={
          <IconButton
            onClick={handleOpen}
            sx={{ mt: 3, p: 0, transform: "scale(1.3)" }}
          >
            {getIcon()}
          </IconButton>
        }
        label=""
      />
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        PaperProps={{
          elevation: 3,
          sx: {
            border: "1px solid #ccc",
            borderRadius: "8px",
            mt: 0,
          },
        }}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
      >
        <MenuItem
          selected={status === "true"}
          onClick={() => handleSelect("true")}
        >
          Complete
        </MenuItem>
        <MenuItem
          selected={status === "omitted"}
          onClick={() => handleSelect("omitted")}
        >
          Omit
        </MenuItem>
        <MenuItem
          selected={status === "none"}
          onClick={() => handleSelect("none")}
        >
          Cancel
        </MenuItem>
      </Menu>
    </>
  );
};

export default TaskCheckbox;
